<template>
  <!-- TODO: 빈 컨텐츠 -->
  <div class="empty-content">
    <div class="empty-grp">
      <div class="icon-grp">
        <i class="icon icon-empty" />
      </div>
      <p class="empty-tt" v-text="txt" />
    </div>
  </div>
  <!-- END 빈 컨텐츠 -->
</template>

<script>
export default {
  name: "EmptyContent",
  props: {
    txt: {
      type: String,
      default: "컨텐츠가 없습니다", // 기본 빈컨텐츠 입니다.
    },
  },
};
</script>

<style scoped></style>
